export default __webpack_public_path__ + "static/media/blur-1310.dec6dcca.png";